<template>
  <div class="cp-table">
    <v-card-title class="pa-0">
      <div class="mb-3">
        {{ header }}
      </div>
    </v-card-title>
    <v-data-table
      :headers="headers.commercialPrint[this.label]"
      :items="commercialPrintList"
      hide-default-footer
      :loading="isLoading"
      :items-per-page="100"
      class="custom-table mt-6"
    >
      <template #[`item.name`]="{ item }">
        <router-link
          class="darken--text underlined-hover"
          :to="{ name: 'commercial-print-single', params: { id: item.id } }"
        >
          {{ item.name }}
        </router-link>
      </template>

      <template #[`item.status`]="{ item }">
        {{ item.status }}
      </template>

      <template #[`item.orderers`]="{ item }">
        <div class="d-flex flex-column">
          <div
            v-for="orderer in item.orderers"
            :key="orderer.id"
          >
            {{ orderer.firstName }} {{ orderer.lastName }}
          </div>
        </div>
      </template>

      <template #[`item.members`]="{ item }">
        <div class="d-flex flex-column">
          <div
            v-for="member in item.members"
            :key="member.id"
          >
            {{ member.firstName }} {{ member.lastName }}
          </div>
        </div>
      </template>

      <template #[`item.bell`]="{ item }">
        <CommercialPrintActionsBell :commercial-print="item" />
      </template>

      <template #no-data>
        <AppEmptyList
          key="emptyList"
          class="py-16"
          header="Brak dostępnych wniosków."
          text="Brak dostępnych wniosków."
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import headers from '@/helpers/tableHeaders';
import AppEmptyList from '@/components/UI/AppEmptyList.vue';
import CommercialPrintActionsBell from '@/components/CommercialPrint/CommercialPrintActionsBell.vue';

export default {
  components: {
    AppEmptyList,
    CommercialPrintActionsBell,
  },

  props: {
    label: {
      type: String,
      required: true,
    },
    commercialPrintList: {
      type: Array,
      required: true,
    },
    header: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      headers,
    };
  },

  computed: {
    ...mapState(['isLoading']),
  },
};
</script>

<style lang="scss" scoped>
.cp-table {
  min-height: 500px;
}
</style>
